<template>
<el-dialog v-if="visible" title="报价截止时间" width="40%" :visible.sync="visible" :key="timer" append-to-body @close="cancel()">
   <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="0px" class="org-dialog-form" size="small">
        <div class="des_box">
            <el-descriptions class="margin-top" :column="2" size="small" border>
                <el-descriptions-item label="报价截止时间" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item style="margin-bottom: 0;" prop="deliveryDate">
                        <el-date-picker v-model="deliveryDate" format="yyyy/MM/dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期" :picker-options="pickerOptions">
                        </el-date-picker>
                    </el-form-item>
                </el-descriptions-item>
            </el-descriptions>
        </div>
    </el-form>
    <div slot="footer">
        <el-button @click="cancel()">取 消</el-button>
        <el-button type="primary" @click="confirm()">确认</el-button>
    </div>
</el-dialog>
</template>

<script>

export default {
    data() {
        return {
            visible: false,
            timer:'',
            deliveryDate: '',
            rfq:'',
            pickerOptions: { //禁用当前日期之前的日期
                disabledDate(time) {
                    var dateTime = new Date();
                    dateTime=dateTime.setDate(dateTime.getDate()+1);
                    return time.getTime() < new Date(dateTime).getTime() - 8.64e7;
                },
            },
        }
    },
    mounted() {},
    methods: {
        init(rfq) {
            debugger
            // console.log(rfq);
            this.visible = true
            // this.rfq = rfq
        },
        confirm() {
            debugger
            this.$emit('confirm', this.deliveryDate)
            this.visible = false
        },
        cancel() {
            this.visible = false
            this.$emit('update:visible', false)
        },
        receivePicker: {
            disabledDate(time) {
                return time.getTime() < Date.now() - 8.64e7;
            }
        },
        getStyle() {
            return 'width: 110px; text-align: right'
        },
        getStyle2() {
            return 'width: 640.5px;'
        }
    },
}
</script>

<style lang="scss">
.el-dialog__body {
    .org-dialog-form {
        width: 95%;
    }
}

.linetext {
    white-space: pre-line;
}
</style>
